/**
 * Popup zu einer Anlage auf der Karte: die Angaben, die auch die Anlagenliste zeigt –
 * Bezeichnung, Hersteller und Typ, Nennleistung und Referenzertrag. Der Titel führt zur
 * Anlagenseite.
 */
import React from "react";
import { useNavigate } from "react-router";
import type { LatLngTuple } from "leaflet";
import { MapFeaturePopup, MapFeaturePopupFigures } from "../../../map";
import { GenerationUnit } from "../../../../types";
import { formatEnergyMWh, formatPowerMW } from "../../../../utils/formatters";

/** Die Spitze des Popups sitzt über dem Anlagen-Symbol (24 px, mittig verankert) statt darauf */
const POPUP_OFFSET: [number, number] = [0, -6];

interface GenerationUnitPopupProps {
  projectId: string;
  unit: GenerationUnit;
  position: LatLngTuple;
  onClose: () => void;
}

const GenerationUnitPopup: React.FC<GenerationUnitPopupProps> = ({
  projectId,
  unit,
  position,
  onClose,
}) => {
  const navigate = useNavigate();
  const model = [unit.hersteller, unit.typ].filter(Boolean).join(" ");

  return (
    <MapFeaturePopup
      position={position}
      offset={POPUP_OFFSET}
      onClose={onClose}
      kind="Windenergieanlage"
      title={unit.bezeichnung || unit.anlagen_nr || "Anlage"}
      titleLink={{
        tooltip: "Zu den Anlagen",
        onClick: () => navigate(`/project/${projectId}/generation-units`),
      }}
      subtitle={model || undefined}
    >
      <MapFeaturePopupFigures
        figures={[
          {
            label: "Nennleistung",
            value:
              unit.nennleistung != null
                ? `${formatPowerMW(unit.nennleistung)} MW`
                : "-",
          },
          {
            label: "Referenzertrag",
            value:
              unit.referenzertrag != null
                ? `${formatEnergyMWh(unit.referenzertrag)} MWh`
                : "-",
          },
        ]}
      />
    </MapFeaturePopup>
  );
};

export default GenerationUnitPopup;
